module.exports = __webpack_public_path__ + "static/media/bankit.e9bc9eb6.png";